import { Box, Checkbox, FormControl, TextInput } from '@primer/react';
import { useCallback, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { crmHocSinhApi } from '../../../api/crmHocSinhApi';
import { loaiSucKhoeApi } from '../../../api/loaiSucKhoeApi';
import { sucKhoeApi } from '../../../api/sucKhoeApi';
import Button from '../../../components/ui/button';
import { showNotify } from '../../../helpers/toast';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { IStudentBaseInformation } from '../../../models/request/acceptance-form/IStudentBaseInformation';
import { dm_loaisuckhoe } from '../../../models/response/category/dm_loaisuckhoe';
import { IDmSucKhoe } from '../../../models/response/category/dm_suckhoe';
import LichSuXuongPhongYTePage from './LichSuXuongPhongYTe';

export interface ISucKhoeHocSinhProps {
    ts_hocsinh_id: number;
    canEdit?: boolean;
}

const SucKhoeHocSinhPage = (props: ISucKhoeHocSinhProps) => {
    const { canEdit = true } = props;
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const [danhMucLoaiSucKhoes, setDanhMucLoaiSucKhoes] = useState<dm_loaisuckhoe[]>([]);
    const [danhMucSucKhoes, setDanhMucSucKhoes] = useState<IDmSucKhoe[]>([]);
    const [studentInformations, setStudentInformations] = useState<IStudentBaseInformation>();

    const { register, handleSubmit, setValue, getValues, control, watch, reset, formState: { errors } } = useForm<IStudentBaseInformation>({
        defaultValues: studentInformations
    });

    useEffect(() => {
        handleGetDanhMucLoaiSucKhoes();
        handleGetDanhMucSucKhoes();
        handleGetHocSinhData();
    }, [props.ts_hocsinh_id]);

    useEffect(() => {
        if (studentInformations) {
            reset(studentInformations, { keepDirty: true, keepTouched: true, keepIsValidating: true });
        }
    }, [studentInformations]);

    const handleGetDanhMucLoaiSucKhoes = async () => {
        const res = await loaiSucKhoeApi.select_all();
        if (res.is_success) {
            setDanhMucLoaiSucKhoes(res.data.filter((x: any) => x.dm_coso_id === dm_coso_id && x.nam_hoc == nam_hoc));
        }
    };
    const handleGetDanhMucSucKhoes = async () => {
        const res = await sucKhoeApi.selectAllView();
        if (res.is_success) {
            setDanhMucSucKhoes(res.data.filter((x: any) => x.dm_coso_id === dm_coso_id && x.nam_hoc == nam_hoc));
        }
    };
    const handleGetHocSinhData = async () => {
        const res = await crmHocSinhApi.getById(props.ts_hocsinh_id, '2024-2025');
        if (res.is_success) {
            setStudentInformations(res.data);
        }
    };

    const onSubmit = (data: IStudentBaseInformation) => {
        handleUpdateHealthInformation(data);
    };

    const handleUpdateHealthInformation = useCallback(async (data: IStudentBaseInformation) => {
        const res = await crmHocSinhApi.updateAcceptanceForm(data);
        if (res.is_success) {
            handleGetHocSinhData();
            showNotify({ message: 'Cập nhật thành công', type: 'success' });
        }
    }, []);
    const handleCheckboxChange = (index: any, dm_suckhoe_id: number, checked: boolean) => {
        const currentResponse = getValues("student_health_response") || [];
        if (index > 1000) {
            const updatedResponse = currentResponse.filter((_, idx) => idx !== index);
            setValue("student_health_response", updatedResponse);
            const currentGhiChu = getValues(`student_health_response.${index}.ghi_chu`) || '';
            const newValue = {
                id: dm_suckhoe_id,
                ts_hocsinh_id: props.ts_hocsinh_id,
                dm_suckhoe_id: dm_suckhoe_id,
                is_tick: checked,
                ghi_chu: currentGhiChu,
            };

            setValue("student_health_response", [...updatedResponse, newValue]);
        } else {
            const currentGhiChu = getValues(`student_health_response.${index}.ghi_chu`) || '';
            const newValue = {
                id: dm_suckhoe_id,
                ts_hocsinh_id: props.ts_hocsinh_id,
                dm_suckhoe_id: dm_suckhoe_id,
                is_tick: checked,
                ghi_chu: currentGhiChu,
            };
            if (currentResponse.some(item => item.dm_suckhoe_id === dm_suckhoe_id)) {
                setValue(`student_health_response.${index}`, newValue);
            } else {
                setValue("student_health_response", [...currentResponse, newValue]);
            }
        }
    };
    const handleGhiChuChange = (index: any, dm_suckhoe_id: number, ghi_chu: string) => {
        const currentResponse = getValues("student_health_response") || [];
        const existingItem = currentResponse.find(item => item.dm_suckhoe_id === dm_suckhoe_id);
        if (existingItem) {
            const updatedItem = {
                ...existingItem,
                ghi_chu: ghi_chu,  // 
            };
            const existingItemIndex = currentResponse.findIndex(item => item.dm_suckhoe_id === dm_suckhoe_id);
            setValue(`student_health_response.${existingItemIndex}`, updatedItem);
        }
    };

    const generateRandomId = () => {
        return Math.floor(Math.random() * 900) + 1000;
    };
    return (
        <>
            <Box>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Box sx={{ fontSize: 16, fontWeight: 600 }}>Thông tin tiểu sử bệnh tật của học sinh:</Box>
                        {canEdit && (
                            <Box>
                                <Button
                                    text="Cập nhật"
                                    variant="primary"
                                    size="medium"
                                    type="submit"
                                />
                            </Box>
                        )}
                    </Box>
                    <Box
                        sx={{
                            border: "1px solid",
                            borderColor: "border.default",
                            borderRadius: 2,
                            maxHeight: "calc(100vh - 360px)",
                            overflowY: "auto",
                        }}
                    >
                        <Box sx={{ display: "grid", gap: 2, p: 2 }}>
                            {danhMucLoaiSucKhoes.length > 0 && danhMucLoaiSucKhoes.map((loaisuckhoe) => {
                                const danhMucByLoaiSucKhoes = danhMucSucKhoes.filter(x => x.dm_loaisuckhoe_id == loaisuckhoe.id);
                                return (
                                    <Box sx={{ pt: 1, pb: 2 }} key={loaisuckhoe.id}>
                                        <Box
                                            sx={{
                                                fontSize: 16,
                                                fontWeight: 600,
                                                mb: 2,
                                                fontStyle: "italic",
                                                textDecoration: "underline",
                                                color: '#0A4FBE'
                                            }}
                                        >
                                            {danhMucByLoaiSucKhoes.length > 0 ? danhMucByLoaiSucKhoes[0].loai_suc_khoe : ''}
                                        </Box>
                                        {(danhMucByLoaiSucKhoes.length > 0 && danhMucByLoaiSucKhoes[0].is_yesno_question === false) && (
                                            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                                                {danhMucByLoaiSucKhoes.map((x) => {
                                                    let index = studentInformations?.student_health_response.findIndex(item => item.dm_suckhoe_id === x.dm_suckhoe_id);
                                                    if (index === undefined || index === -1) {
                                                        index = generateRandomId();
                                                    }
                                                    return (
                                                        <Box
                                                            key={x.id}
                                                            sx={{
                                                                width: "33%",
                                                                mb: 1,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 1,
                                                            }}
                                                        >
                                                            {x.is_checkbox && (
                                                                <Controller
                                                                    name={`student_health_response.${index}.is_tick`}
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field }) => (
                                                                        <FormControl>
                                                                            <FormControl.Label>{x.name}</FormControl.Label>
                                                                            <Checkbox
                                                                                {...field}
                                                                                value={field.value?.toString()}
                                                                                checked={field.value ?? false}
                                                                                onChange={(e) => {
                                                                                    const checked = e.target.checked;
                                                                                    field.onChange(checked);
                                                                                    handleCheckboxChange(index, x.dm_suckhoe_id, checked);
                                                                                }}
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                />
                                                            )}

                                                            {x.is_yesno_question && (
                                                                <Controller
                                                                    name={`student_health_response.${index}.is_tick`}
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field }) => (
                                                                        <FormControl sx={{ mb: 1 }}>
                                                                            <FormControl.Label>{x.name}</FormControl.Label>
                                                                            <Box
                                                                                sx={{
                                                                                    display: "grid",
                                                                                    gap: 1,
                                                                                    gridTemplateColumns: "1fr 1fr",
                                                                                    mt: 2,
                                                                                }}
                                                                            >
                                                                                <FormControl>
                                                                                    <FormControl.Label>Có</FormControl.Label>
                                                                                    <Checkbox
                                                                                        {...field}
                                                                                        value={field.value?.toString()}
                                                                                        checked={field.value ?? false}
                                                                                        onChange={(e) => {
                                                                                            const checked = e.target.checked;
                                                                                            field.onChange(checked);
                                                                                            handleCheckboxChange(index, x.dm_suckhoe_id, checked);
                                                                                        }}
                                                                                    />
                                                                                </FormControl>
                                                                                <FormControl>
                                                                                    <FormControl.Label>Không</FormControl.Label>
                                                                                    <Checkbox
                                                                                        {...field}
                                                                                        value={field.value?.toString()}
                                                                                        checked={!field.value}
                                                                                        onChange={(e) => {
                                                                                            const checked = !e.target.checked;
                                                                                            field.onChange(checked);
                                                                                            handleCheckboxChange(index, x.dm_suckhoe_id, checked);
                                                                                        }}
                                                                                    />
                                                                                </FormControl>
                                                                            </Box>
                                                                        </FormControl>
                                                                    )}
                                                                />
                                                            )}

                                                            {x.is_show_note && (
                                                                <Controller
                                                                    name={`student_health_response.${index}.ghi_chu`} // Đảm bảo tên này phù hợp
                                                                    control={control}
                                                                    defaultValue=""
                                                                    render={({ field }) => (
                                                                        <FormControl sx={{ marginLeft: "auto", pl: 2, pr: 3 }}>
                                                                            <FormControl.Label visuallyHidden>Ghi chú</FormControl.Label>
                                                                            <TextInput
                                                                                width={"200px"}
                                                                                block
                                                                                placeholder="Ghi chú"
                                                                                {...field}
                                                                                onChange={(e) => {
                                                                                    field.onChange(e.target.value);
                                                                                    handleGhiChuChange(index, x.dm_suckhoe_id, e.target.value);
                                                                                }}
                                                                            />
                                                                            {/* {errors?.student_health_response?.[index]?.ghi_chu?.message && (
                                                                            <span style={{ color: "red" }}>
                                                                                {errors.student_health_response[index].ghi_chu.message}
                                                                            </span>
                                                                        )} */}

                                                                        </FormControl>
                                                                    )}
                                                                />

                                                            )}
                                                        </Box>
                                                    );
                                                })}

                                            </Box>
                                        )}
                                        {(danhMucByLoaiSucKhoes.length > 0 && danhMucByLoaiSucKhoes[0].is_yesno_question === true) && (
                                            <Box
                                                sx={{
                                                    display: "grid",
                                                    gap: 2,
                                                    gridTemplateColumns: "repeat(3, 1fr)",
                                                }}
                                            >
                                                {danhMucByLoaiSucKhoes.map((x, idx) => {
                                                    let index = studentInformations?.student_health_response.findIndex(item => item.dm_suckhoe_id === x.dm_suckhoe_id);
                                                    if (index === undefined || index === -1) {
                                                        index = generateRandomId();
                                                    }
                                                    return (
                                                        <FormControl key={idx} sx={{ mb: 2 }}>
                                                            <FormControl.Label>{x.name}</FormControl.Label>
                                                            <Box
                                                                sx={{
                                                                    display: "grid",
                                                                    gap: 2,
                                                                    gridTemplateColumns: "1fr 1fr",
                                                                    mt: 2,
                                                                }}
                                                            >
                                                                <Controller
                                                                    name={`student_health_response.${index}.is_tick`}
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field }) => (
                                                                        <FormControl>
                                                                            <FormControl.Label>Có</FormControl.Label>
                                                                            <Checkbox
                                                                                {...field}
                                                                                value={field.value?.toString()}
                                                                                checked={field.value ?? false}
                                                                                onChange={(e) => {
                                                                                    const checked = e.target.checked;
                                                                                    field.onChange(checked);
                                                                                    handleCheckboxChange(index, x.dm_suckhoe_id, checked);
                                                                                }}
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                />
                                                                <Controller
                                                                    name={`student_health_response.${index}.is_tick`}
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field }) => (
                                                                        <FormControl>
                                                                            <FormControl.Label>Không</FormControl.Label>
                                                                            <Checkbox
                                                                                {...field}
                                                                                value={field.value?.toString()}
                                                                                checked={!field.value}
                                                                                onChange={(e) => {
                                                                                    const checked = !e.target.checked;
                                                                                    field.onChange(checked);
                                                                                    handleCheckboxChange(index, x.dm_suckhoe_id, checked);
                                                                                }}
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                />
                                                            </Box>
                                                            {x.is_show_note && (
                                                                <Box sx={{ gridColumn: "span 2", mt: 2 }}>
                                                                    <Controller
                                                                        name={`student_health_response.${index}.ghi_chu`}
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => (
                                                                            <TextInput
                                                                                width={"200px"}
                                                                                block
                                                                                placeholder="Ghi chú"
                                                                                {...field}
                                                                                onChange={(e) => {
                                                                                    field.onChange(e.target.value);
                                                                                    handleGhiChuChange(index, x.dm_suckhoe_id, e.target.value);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Box>
                                                            )}
                                                        </FormControl>
                                                    );
                                                })}
                                            </Box>
                                        )}

                                    </Box>
                                );
                            })}

                        </Box>
                    </Box>
                </form>

            </Box>
            <LichSuXuongPhongYTePage hocSinhId={props.ts_hocsinh_id} canEdit={canEdit} />
        </>


    );
};

export default SucKhoeHocSinhPage;
